import {
  TableBody,
  TableCell,
  TableRow,
  Badge
} from "@windmill/react-ui";

const RevenueReportTable = ({ RevenueReport:data , hideEdit , hideDelete, hideView, hideExport}) => {
 
  return (
    <TableBody>
      {data?.map((item, index) => (
        <TableRow key={item?.bookingId || index}>
          <TableCell className="text-center">{index + 1}</TableCell>
          <TableCell className="text-center">
            {/* {console.log(item)} */}
            <div>{item.agentId}</div>
            <div className="text-center">{item.ref_no}</div>
          </TableCell>
          <TableCell className="text-center text-sm">{item.agent_company_name}</TableCell>
      
           <TableCell className="text-center text-sm">
               <div>
                 <span className="text-green-500 font-medium">A:</span> <span>{item.arrival_city || "-"}</span>
               </div>
               <div className="pt-3">
                 <span className="text-red-500 font-medium">D:</span> <span>{item.departure_city || "-"}</span>
               </div>
             </TableCell>
                <TableCell className="text-center">
          {item.start_date && item.end_date ? (
            <>
              <div>{new Date(item.start_date).toLocaleDateString("en-GB")}</div>
              <div className="pt-3">{new Date(item.end_date).toLocaleDateString("en-GB")}</div>
            </>
          ) : (
            "-"
          )}
        </TableCell>
          <TableCell className="text-center">{item.sales_amount}</TableCell>
          <TableCell className="text-center">{item.transport_price_excl_gst}</TableCell>
         <TableCell className="text-center">{item.gst_5_percent}</TableCell>
          <TableCell className="text-center">{item.total_vehicle_bill_amount}</TableCell>
  <TableCell className="text-center">
  <div>
    {/* Profit Amount */}
    {(item.transport_price_excl_gst - Number(item.total_vehicle_bill_amount)).toFixed(2)}
  </div>
  <div className="text-xs text-gray-500 mt-1">
    {/* Profit Percentage */}
    {(
      ((item.transport_price_excl_gst - Number(item.total_vehicle_bill_amount)) 
        / item.transport_price_excl_gst) * 100
    ).toFixed(1)}%
  </div>
</TableCell>


         <TableCell
  className={`text-center font-semibold ${
    item.transport_price_excl_gst - Number(item.total_vehicle_bill_amount) >= 0
      ? "text-green-600"
      : "text-red-600"
  }`}
>
  {item.transport_price_excl_gst- Number(item.total_vehicle_bill_amount) >= 0 ? "Profit" : "Loss"}
</TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};

export default RevenueReportTable;
